/**
 * Entitlement Invalid Banner
 *
 * Displays a warning banner when the team's entitlement data is missing or invalid.
 * This helps users understand why certain features may not work correctly.
 */

import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTeam } from '@/contexts/TeamContext';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export function EntitlementInvalidBanner() {
  const { entitlementInvalid, entitlementInvalidReason } = useTeam();
  const { t } = useTranslation('common');

  if (!entitlementInvalid) {
    return null;
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>{t('entitlementInvalid.title')}</AlertTitle>
      <AlertDescription className="flex items-center justify-between">
        <span>{entitlementInvalidReason || t('entitlementInvalid.defaultMessage')}</span>
        <Button variant="outline" size="sm" onClick={handleRefresh} className="ml-4 shrink-0">
          <RefreshCw className="h-4 w-4 mr-2" />
          {t('entitlementInvalid.refresh')}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
